import { Component, OnDestroy, ElementRef, ViewChild, OnInit, AfterContentInit, ViewContainerRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DossierSituation, ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { Router } from '@angular/router';
import { DossierModelsService } from './DossierModels.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import {
  ProcurementProjectDefinitionsDTO, ProcurementProjectStepsDefinitionDTO
} from '../../api/plyca-dtos';

import { catchError, debounceTime, distinctUntilChanged, filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { EMPTY, fromEvent, Observable, Subscription } from 'rxjs';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { UserService } from '../../user.service';

const TABLE_COLUMN_ID = 'ColId';
const TABLE_COLUMN_TYPE = 'colType';
const TABLE_COLUMN_STATUS = 'colStatus';

@Component({
  selector: 'dossierModels',
  templateUrl: 'dossierModels.template.html',
  providers: [DialogService]
})
export class dossierModelsComponent extends BaseComponent implements OnInit, AfterContentInit, OnDestroy {


  loaded = false;

  public models: ProjectEntityDTO[];
  public filteredModels: any[];
  public filter: string;
  public filterText: string;
  public MIN_SEARCH_TEXT_LENGHT = 3;
  columns: any[];
  windowHash: string;
  tagsParent: string[] = [];
  // Listado de configuraciones definidas en ProcurementProjectDefinition.json
  definitions: Array<ProcurementProjectStepsDefinitionDTO>;
  public popupModelTypesVisible: boolean;
  private searchSubscription: Subscription;




  constructor(
    public plycaService: PlycaDataService,
    public dossierModelService: DossierModelsService,
    private helpService: HelpService,
    public configuration: Configuration,
    public router: Router,
    private uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef,
    private userService: UserService
  ) {
    super();

    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => {
        this.tagsParent = helpTags

        return this.helpService.showContextHelpObservable(HelpType.MODEL_DOSSIER_CONTROL_PANEL);

      })));
    // definicion de los campos asociados a las columnas
    this.columns = [
      { field: TABLE_COLUMN_ID, header: 'DossiersView.id.dossier' },
      { field: 'abbreviatedTitle', header: 'DossiersView.id.description' },
      { field: TABLE_COLUMN_TYPE, header: 'ProcurementProject.models.type' },
      { field: TABLE_COLUMN_STATUS, header: 'General.state' }
    ];
  }

  ngAfterContentInit() {


    this.loaded = true;
  }

  ngOnInit(): void {
    // Cargar tipos de expedientes
    this.subscribe(
      this.plycaService
        .getProcurementProjectSteps(
          'procurementProject/procurementProjectDefinition.json'
        ).pipe(
          take(1)
        ), ((stepsDef: ProcurementProjectDefinitionsDTO) => {
          this.definitions = stepsDef.definitions;
        }))



    // establecer acciones cabecera
    this.headerActionsService.setTaskDescription(this.elem, 'ProcurementProject.models.adm', 'far fa-clipboard', this.isLoaded.bind(this));
    // accion crear

    this.subscribe(
      this.headerActionsService.addWindowAction(
        'ProcurementProject.models.create',
        'far fa-clone',
        'btn-primary',
        true,
        this.windowHash
      )
      ,

      success => {
        this.loadConfigDefinitions(true);
      }
    );

    // accion refrescar

    this.subscribe(this.headerActionsService.addAction(
      'General.reload',
      'fas fa-sync-alt',
      'btn-secondary',
      true
    ),
      success => {
        this.loadModels();
      }

    );



    // accion volver

    this.headerActionsService.addDivider();

    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        this.uiService.routeBack();
      }));

    this.loadModels();
  }

  private loadModels() {
    let uoIdentifier = this.userService.getUser()?.organizationalUnit?.identifier;
    this.waitService.startWaiting();
    this.subscribe(
      this.dossierModelService.getUserUOModels([DossierSituation.Normal, DossierSituation.Draft], null, uoIdentifier).pipe(
        take(1)
      ),
      // this.dossierModelService.getModels([DossierSituation.Normal, DossierSituation.Draft]).pipe(
      //   take(1)
      // ),
      result => {
        if (result) {
          this.models = result.content;
        } else {
          this.models = [];
        }
        // this.loadConfigDefinitions(false);
        this.updateFilter();
      },

      (error: any) => {
        console.error(error);
        this.waitService.cancelWaiting();
      },
      () => this.waitService.cancelWaiting()
    );
  }

  private getTypeName(formid: string): string {
    if (this.definitions) {
      let element = this.definitions.find(x => x.identifier === formid);

      return (element && element.name) ? element.name : '';
    } else { return ''; }
  }

  private loadConfigDefinitions(visible: boolean) {
    if (visible) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREATE_MODEL));
    }
    this.popupModelTypesVisible = visible;
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {

        this.headerActionsService.clearWindowActions(this.windowHash);

        this.helpService.clearContextHelp();
        super.ngOnDestroy();
      })));
  }

  public isLoaded() {
    return this.loaded;
  }

  public updateFilter(): void {
    let modelAuxList = []
    this.models.map((model: ProjectEntityDTO) => {
      model[TABLE_COLUMN_ID] = model.contractFolderId || model.identifier;
      model[TABLE_COLUMN_TYPE] = this.getTypeName(model.formId);
      model[TABLE_COLUMN_STATUS] = this.getStatus(model);
      modelAuxList.push(model);
    });
    if (this.filterText) {
      modelAuxList = modelAuxList.filter((model: ProjectEntityDTO) =>
        (model.abbreviatedTitle && model.abbreviatedTitle.toLowerCase().indexOf(this.filterText.toLowerCase().trim()) > -1)
        ||
        (model[TABLE_COLUMN_ID] && model[TABLE_COLUMN_ID].toLowerCase().indexOf(this.filterText.toLowerCase().trim()) > -1)
      )
    }
    this.filteredModels = modelAuxList;
  }

  public createModel(tipo: any) {
    //this.router.navigate(['procurementProject'], { queryParams: { model: true, formid: tipo.identifier, formUUID: tipo.formUUID } });
    this.router.navigate(['procurementProject'], { queryParams: { model: true, formUUID: tipo.formUUID } });
  }

  public deleteModel(model: ProjectEntityDTO): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('ProcurementProject.models.delete'),
      accept: () => {
        this.updateModelStatus(model, DossierSituation.Cancelled);
      }
    });
  }

  private getStatus(model: ProjectEntityDTO): string {
    let status: string;
    if (model.status && model.status.situation === DossierSituation.Normal) {
      status = this.translateService.instant('ProcurementProject.models.status.publish');
    } else {
      status = this.translateService.instant('ProcurementProject.models.status.unpublish');
    }
    return status;
  }

  public unpublishModel(model: ProjectEntityDTO) {
    this.confirmationService.confirm({
      message: this.translateService.instant('ProcurementProject.models.unpublish'),
      accept: () => {
        this.updateModelStatus(model, DossierSituation.Draft);
      }
    });
  }

  public publishModel(model: ProjectEntityDTO) {
    this.confirmationService.confirm({
      message: this.translateService.instant('ProcurementProject.models.publish'),
      accept: () => {
        this.updateModelStatus(model, DossierSituation.Normal);
      }
    });
  }

  private updateModelStatus(model: ProjectEntityDTO, status: DossierSituation) {
    this.subscribe(this.dossierModelService.updateModelStatus(model, status).pipe(
      catchError((error: any) => this.manageError(error)),
      finalize(() => this.loadModels())
    ));
  }

  private manageError(error: any): Observable<any> {
    this.waitService.cancelWaiting();
    this.plycaErrorHandler.showServerError(error);
    return EMPTY;
  }

  public isModelPublished(model: ProjectEntityDTO): boolean {
    return model.status && model.status.situation === DossierSituation.Normal;
  }

}
